<template lang="html">
  <div>
    <h1>SPECIALTIES</h1>
    <v-layout>
      <v-text-field v-model="name" solo label="Name"></v-text-field>
      <v-btn :disabled="(name != null && name != '') ? false : true" @click="createSpeciality" text color="success">add
        new specialty</v-btn>
    </v-layout>
    <v-layout>
      <v-text-field @input="seatchMethod" v-model="search" solo label="Search"></v-text-field>
    </v-layout>
    <v-layout>
      <v-data-table v-if="specialties.length" :headers="[
        /* { text: 'NUMBER', value: 'id_playlist' }, */
        { text: 'ID', value: 'id' },
        { text: 'NAME', value: 'name' },
        { text: 'DELETE', value: 'actions' },

      ]" :items="filteredSpecialties">
        <template v-slot:item.actions="{ item }">
          <v-btn @click="deleteItem(item)" text color="error">DELETE</v-btn>
        </template>
      </v-data-table>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      filteredSpecialties: null,
      specialties: null,
      search: ''
    };
  },
  methods: {
    seatchMethod(val) {
      if (this.search == '') {
        this.filteredSpecialties = this.specialties.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;;
      }
      else {
        this.filteredSpecialties = this.specialties.filter(element => {
          return (element.name).includes(this.search)
        });
      }
    },
    async createSpeciality() {
      if (this.name != null && this.name != "")
        await axios
          .post("/specialties/create", {
            name: this.name
          }).then(() => {
            this.sync();
            this.name = null;
          })
    },
    async deleteItem(item) {
      await axios
        .post("/specialties/delete", { id: item.id }).then(() => {
          this.sync();
        })
    },
    async sync() {
      await axios
        .get("/specialties").then((res) => {
          this.specialties = res.data.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
            const nameB = b.name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0; // Names are equal
          });

          this.filteredSpecialties = res.data.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
            const nameB = b.name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0; // Names are equal
          });
        });
    },
  },
  created() {
    this.sync();
  },
  computed: {

  }
}
</script>

<style lang="scss" scoped>
.inputs>* {
  margin: 10px;
  width: calc(50% - 20px);
}
</style>
